import { genericService } from "./genericService";

function getAll(id) {
  return genericService.get("Locality/ListAllLocality/" + id);
}

export const localityService = {
  getAll,
};
